// extracted by mini-css-extract-plugin
export default {"zodiacContainer":"BestMatchesReport_zodiacContainer__Lgl5E"};